import React from "react";
import Container from "@mui/material/Container";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import BannerItem from "./BannerItem";
import { NSApps } from "../../types";
import { neutral } from "../../../../common/config/colors";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Banner: React.FC<{
  banners: NSApps.IBannerItem[];
  deviceType: string;
}> = ({ banners, deviceType }) => {
  return (
    <Container
      maxWidth="xl"
      sx={{
        pt: 2,
        maxWidth: "1365px !important",
        "& a": {
          textDecoration: "none",
        },
        "& .react-multiple-carousel__arrow": {
          minWidth: { xs: 24, md: 45 },
          minHeight: { xs: 24, md: 45 },
        },
        "& .react-multiple-carousel__arrow--right": {
          right: "calc(1% + 1px)",
          background: "rgba(255, 255, 255, 0.87)",
          backdropFilter: "blur(5px)",
          width: { xs: 24, md: 45 },
          height: { xs: 24, md: 45 },
          "&:hover": {
            background: "rgba(255, 255, 255, 0.87)",
          },
        },
        "& .react-multiple-carousel__arrow--left": {
          left: "calc(1% + 1px)",
          background: "rgba(255, 255, 255, 0.87)",
          backdropFilter: "blur(5px)",
          width: { xs: 24, md: 45 },
          height: { xs: 24, md: 45 },
          "&:hover": {
            background: "rgba(255, 255, 255, 0.87)",
          },
        },
        "& .react-multiple-carousel__arrow::before": {
          color: neutral[900],
          fontSize: { xs: 14, md: 20 },
        },
      }}
    >
      <Carousel
        responsive={responsive}
        deviceType={deviceType}
        ssr={true}
        infinite={true}
        keyBoardControl={true}
      >
        {banners.map((banner, idx) => (
          <BannerItem key={banner.id} idx={idx} {...banner} />
        ))}
      </Carousel>
    </Container>
  );
};

export default Banner;
